export default __webpack_public_path__ + "static/Friday-0717930b9990de1f1442367fdabeb431.png";